import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { match } from 'ts-pattern';

import type { Invoice, InvoiceStatus } from '~/api/invoices/types';

import { Tooltip } from '~/components';
import { statusColorThemes } from '~/styles/themes.css';
import { clsx } from '~/styles/utils';
import { includes } from '~/utils/arrays';

import { InvoiceStatusTag } from '../InvoiceStatusTag';
import { statusCellStyle, statusRowStyle, substatusStyle } from './invoiceCell.css';

type Props = {
  invoice: Invoice;
};

export const InvoiceStatusCell = ({ invoice }: Props) => {
  const { t } = useTranslation(['invoices']);

  const tooltipContent = match(invoice)
    .with({ status: 'Approved', coTransportType: 'Peppol' }, () => t('invoices:overview.columns.status.sentWithPeppolTooltip'))
    .with({ status: 'LockedByUser' }, () => t('invoices:overview.columns.status.lockedByUserTooltip'))
    .with({ status: 'CoPaid' }, () => dayjs(invoice.coPaidDate).format('DD/MM/YYYY'))
    .with({ status: 'FcPaid' }, () => dayjs(invoice.fcPaidDate).format('DD/MM/YYYY'))
    .otherwise(() => null);

  return (
    <Tooltip content={tooltipContent} disableHoverablePopup>
      <div className={statusCellStyle}>
        <div className={statusRowStyle}>
          <InvoiceStatusTag status={invoice.status} />
        </div>

        {invoice.hasPaymentFollowUp && (
          <div className={clsx(substatusStyle, statusColorThemes.danger)}>{t('invoices:overview.columns.substatus.PaymentInFollowUp')}</div>
        )}

        {invoice.coPartiallyPaid && includes(['Approved', 'Expired'] as InvoiceStatus[], invoice.status) && !invoice.hasPaymentFollowUp && (
          <div className={clsx(substatusStyle, statusColorThemes.info)}>{t('invoices:overview.columns.substatus.CoPartiallyPaid')}</div>
        )}
      </div>
    </Tooltip>
  );
};
